import { render } from "./RecentInvoices.vue?vue&type=template&id=3c5c2e1c"
import script from "./RecentInvoices.vue?vue&type=script&lang=js"
export * from "./RecentInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__